module.exports = __webpack_public_path__ + "img/1.c2a715f6.jpg";